import { render } from "./RefundBooking.vue?vue&type=template&id=a1ddf636&scoped=true&lang=pug"
import script from "./RefundBooking.vue?vue&type=script&lang=ts"
export * from "./RefundBooking.vue?vue&type=script&lang=ts"

import "./RefundBooking.vue?vue&type=style&index=0&id=a1ddf636&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1ddf636"

export default script